import api from "../api";

export default {
  namespaced: true,
  state: {
    applicantPrintInformation: {},
    pdfDocumentUrl: null,
  },
  getters: {
    getApplicantPrintInformation(state) {
      return state.applicantPrintInformation;
    },
    getPdfDocumentUrl(state) {
      return state.pdfDocumentUrl;
    },
  },
  mutations: {
    setApplicantPrintInformation(state, data) {
      state.applicantPrintInformation = data;
    },
    setPdfDocumentUrl(state, url) {
      state.pdfDocumentUrl = url;
    },
  },
  actions: {
    printApplicantInformation({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get(
            `/api/v1/GetApplicantPrintInformation?AdmApplicantId=${localStorage.getItem(
              "admApplicantId"
            )}`
          )
          .then((resp) => {
            if (resp.status === 200) {
              commit("setApplicantPrintInformation", resp.data);

              // We'll use a simpler approach without direct PDF generation
              // Just store the data for display in the component
              const dataUrl = `data:application/json;charset=utf-8,${encodeURIComponent(
                JSON.stringify(resp.data)
              )}`;
              commit("setPdfDocumentUrl", dataUrl);

              resolve({ status: true });
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
